module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Page404"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns is-10 content has-text-white"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "has-text-white"
  }, [_c('p', [_vm._v("Looks like you've just found end of our coworking webpage.")]), _vm._v(" "), _c('p', [_vm._v("You are "), _c('router-link', {
    attrs: {
      "to": "/contact-venue"
    }
  }, [_vm._v("welcome to come over for free day pass 😋")])], 1)]), _vm._v(" "), _c('p', [_vm._v("🎯 Space for focused work")]), _vm._v(" "), _c('p', [_vm._v("🙌\n            "), _c('router-link', {
    attrs: {
      "to": "rent-flex-desk-coworking-bratislava"
    }
  }, [_vm._v("\n            Space for collaborative work\n            ")])], 1), _vm._v(" "), _c('p', [_vm._v("🛋 Space for relaxation")]), _vm._v(" "), _c('p', [_vm._v("🍷 Community Social Events")]), _vm._v(" "), _c('p', [_vm._v("⚡️ Ultra-fast Internet")]), _vm._v(" "), _c('p', [_vm._v("💬 Hangout areas")]), _vm._v(" "), _c('p', [_vm._v("🔐 Private call room")]), _vm._v(" "), _c('p', [_vm._v("🤝\n            "), _c('router-link', {
    attrs: {
      "to": "meeting-room-cowork-bratislava"
    }
  }, [_vm._v("Meeting rooms\n            ")])], 1)])])]), _vm._v(" "), _c('Offer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-8"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cowork/making_movie_cowork.jpg",
      "alt": "coworking bratislava making movie"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45424dd8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page404.vue
// module id = 245
// module chunks = 8